<template>
  <div>
    <v-sheet>
      <v-container fluid>
        <v-row dense>
          <v-col cols="4" md="4">
            <Fletrix-date-picker
              solo
              label="Date"
              :value="searchFilters.selectedDate"
              @input="updateSearchFilter('selectedDate', $event)"
            ></Fletrix-date-picker>
          </v-col>

          <v-col v-if="!isClinicStaff" cols="8" md="8">
            <FletrixSelect
              hide-details="auto"
              label="Clinic"
              :value="searchFilters.selectedClinic"
              @input="updateSearchFilter('selectedClinic', $event)"
              :items="clinicsDropdownList"
              solo
              :menu-props="{ offsetY: true }"
              prepend-inner-icon="mdi-hospital-building"
              clearable
              placeholder="Choose a clinic"
              :item-text="
                item => {
                  // return JSON.stringify(item);
                  return parseAndLocalize(item.text, 'en');
                }
              "
            />
          </v-col>
          <v-col cols="12" md="12">
            <div class="d-flex align-center flex-wrap justify-space-between">
              <div class="d-flex align-center" @click.capture="handleStopBookingClick">
                <v-switch
                  :input-value="stopBooking"
                  label="Stop booking for selected date"
                  hide-details
                  class="mt-0"
                  dense
                  inset
                  :loading="stopBookingLoading"
                  :disabled="stopBookingLoading"
                  readonly
                />
              </div>
              <div class="d-flex align-center flex-wrap">
                <v-radio-group
                  :value="selectedStatus"
                  @change="handleStatusChange"
                  hide-details
                  class="mt-0"
                  dense
                  row
                >
                  <v-radio
                    v-for="status in bookingStatusOptions"
                    :key="status.value"
                    :label="status.text"
                    :value="status.value"
                    off-icon="mdi-checkbox-blank-outline"
                    on-icon="mdi-checkbox-marked"
                    class="mr-3"
                  />
                </v-radio-group>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <!-- <FletrixAlert v-for="memo in unreadMemos" type="memo" @dismiss="dismissMemo(memo._id)"
      >{{ get(memo, 'time.start') | moment('YYYY-MM-DD ddd') }} {{ memo.content }}</FletrixAlert
    > -->
  </div>
</template>

<script>
import {
  FletrixDatePicker,
  // FletrixAlert,
  FletrixSelect,
} from '@/components/Atom';
import api from '@/api';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { tagOption, clinicServiceOption } from '@/data/optionsConstants';
import { getOid } from '@/services/utils';
import { bookingStatus } from '@/data/constants';
import { parseAndLocalize } from '@/services/filters';

export default {
  components: {
    FletrixDatePicker,
    // FletrixAlert,
    FletrixSelect,
  },
  props: {
    searchFilters: {
      type: Object,
      default: () => ({
        searchVal: '',
        selectedDate: new Date(),
        selectedClinic: null,
      }),
    },
    clinicsDropdownList: {
      type: Array,
      default: () => [],
    },
    quickPauseHoliday: {
      type: Object,
      default: null,
    },
    stopBookingLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clinicServiceOption,
      unreadMemos: [],
      unreadNotifications: [],
      tagOption,
    };
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'isClinicStaff']),

    stopBooking: {
      get() {
        return !!this.quickPauseHoliday;
      },
      set(value) {
        // Value will be handled by @change event
      },
    },

    bookingStatusOption() {
      return [
        { text: 'New Booking', value: bookingStatus.created },
        { text: 'Arrived', value: bookingStatus.arrived },
        { text: 'Absent', value: bookingStatus.absent },
        { text: 'Completed', value: bookingStatus.completed },
      ];
    },

    bookingStatusOptions() {
      return [
        { text: 'All', value: 'all' },
        { text: 'Approved', value: 'approved' },
        { text: 'Arrived', value: bookingStatus.arrived },
        { text: 'Pending', value: 'pending' },
        { text: 'Absent', value: bookingStatus.absent },
        { text: 'Completed', value: bookingStatus.completed },
        { text: 'Blocked', value: 'blocked' },
      ];
    },

    selectedStatus() {
      const statuses = this.searchFilters.searchStatus || [];
      return statuses.length > 0 ? statuses[0] : 'all';
    },
  },
  mounted() {},
  watch: {},
  methods: {
    get,
    parseAndLocalize,
    updateSearchFilter(key, value) {
      const updatedFilters = { ...this.searchFilters, [key]: value };
      this.$emit('update:searchFilters', updatedFilters);
    },
    handleStatusChange(statusValue) {
      this.updateSearchFilter('searchStatus', [statusValue]);
    },
    async handleStopBookingClick(event) {
      // Prevent default and stop propagation
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      // Don't do anything if loading or disabled
      if (this.stopBookingLoading) {
        return;
      }

      // Get the new value (opposite of current state)
      const newValue = !this.stopBooking;

      // Show confirmation dialog
      const confirmed = await this.$root.$confirm.open(
        newValue ? 'Stop Booking' : 'Enable Booking',
        newValue
          ? 'Are you sure you want to stop booking for this date? No new bookings will be accepted and existing bookings will be cancelled.'
          : 'Are you sure you want to enable booking for this date?',
        {
          color: newValue ? 'error' : 'success',
        },
      );

      if (!confirmed) {
        // User cancelled - do nothing, switch stays in original state
        return;
      }

      // Emit event to parent to handle the API call
      this.$emit('stopBookingChange', {
        stopBooking: newValue,
        date: this.searchFilters.selectedDate,
        clinic: this.searchFilters.selectedClinic,
        holidayId: this.quickPauseHoliday?._id,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
